import { FieldType } from '@framework/core/Enums';
import { IEntityModelField, IEntityModel } from '@framework/interfaces/IEntityModel';
export interface IStockItemFileCabinetFields {
		id?: any;
		status?: any;
		datestamp?: any;
		changedById?: any;
		stockItemId?: any;
		fileCabinetId?: any;
}

export class StockItemFileCabinetFields extends Array<IEntityModelField> {
	public id: IEntityModelField = { name: "id", displayName: "Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true, keyField: true };
	public status: IEntityModelField = { name: "status", displayName: "Status", fieldType: FieldType.Int, pattern: "NameGeneric", required: true };
	public datestamp: IEntityModelField = { name: "datestamp", displayName: "Datestamp", fieldType: FieldType.DateTime, pattern: "NameGeneric", required: true };
	public changedById: IEntityModelField = { name: "changedById", displayName: "Changed By Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public stockItemId: IEntityModelField = { name: "stockItemId", displayName: "Stock Item Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public fileCabinetId: IEntityModelField = { name: "fileCabinetId", displayName: "File Cabinet Id", fieldType: FieldType.String, pattern: "NameGeneric" };

	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.stockItemId);
		this.push(this.fileCabinetId);
	}
}

export class StockItemFileCabinetDTO implements IEntityModel {
	protected stockItemFileCabinetName: string = "StockItemFileCabinetModel";
	protected stockItemFileCabinetKeyField: string = "id";
	protected stockItemFileCabinetDisplayName: string = "Stock Item File Cabinet|Stock Item File Cabinets";
	protected stockItemFileCabinetFields = new StockItemFileCabinetFields();
	public get name(): string { return this.stockItemFileCabinetName };
	public get keyField(): string { return this.stockItemFileCabinetKeyField };
	public get displayName(): string { return this.stockItemFileCabinetDisplayName };
	public get fields(): StockItemFileCabinetFields { return this.stockItemFileCabinetFields };

	constructor() {};
}
